module.exports = __webpack_public_path__ + "img/75.56335754.png";